"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const Alert_1 = __importDefault(require("../../components/Alert"));
const ArrowButton_1 = __importDefault(require("../../components/ArrowButton"));
const Button_1 = __importDefault(require("../../components/Button"));
const IconType_1 = __importDefault(require("../../components/enums/IconType"));
const IdHeader_1 = __importDefault(require("../../components/IdHeader"));
const IllustrationNoDrawing_1 = __importDefault(require("../../components/illustrations/IllustrationNoDrawing"));
const ResetPasswordEmailSent_1 = __importDefault(require("../../components/popups/ResetPasswordEmailSent"));
const ResetEmailEmailSent_1 = __importDefault(require("../../components/popups/ResetEmailEmailSent"));
const TextInput_1 = __importDefault(require("../../components/TextInput"));
const Profile = () => {
    //Reset password
    const [isPasswordResetDone, setPasswordResetDone] = (0, react_1.useState)(false);
    const [resetEmailSentTo, setResetEmailSentTo] = (0, react_1.useState)("");
    const [isEmailResetDone, setEmailResetDone] = (0, react_1.useState)(false);
    //Profile Form Variables
    const [originalData, setOriginalData] = (0, react_1.useState)({
        firstName: "",
        lastName: "",
        phone: "",
    });
    const [isFormChanged, setIsformChanged] = (0, react_1.useState)(false);
    const [firstName, setFirstName] = (0, react_1.useState)("");
    const [firstNameError, setFirstNameErrorState] = (0, react_1.useState)("");
    const [lastName, setLastName] = (0, react_1.useState)("");
    const [lastNameError, setLastNameErrorState] = (0, react_1.useState)("");
    const [phone, setPhone] = (0, react_1.useState)("");
    const [phoneError, setPhoneErrorState] = (0, react_1.useState)("");
    //Screen State Variables
    const [isDataChanged, setIsDataChanged] = (0, react_1.useState)({
        changed: false,
        error: false,
    });
    const [isFormFilled, setIsFormFilled] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (document.getElementById("react-data")) {
            try {
                let data = document
                    .getElementById("react-data")
                    .getAttribute("encoded");
                let parsed_data = JSON.parse(data);
                if (parsed_data.phone) {
                    setPhone(parsed_data.phone);
                }
                if (parsed_data.first_name) {
                    setFirstName(parsed_data.first_name);
                }
                if (parsed_data.family_name) {
                    setLastName(parsed_data.family_name);
                }
                setOriginalData({
                    firstName: parsed_data.first_name,
                    lastName: parsed_data.family_name,
                    phone: parsed_data.phone,
                });
            }
            catch (error) { }
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (firstName.length !== 0 &&
            lastName.length !== 0 &&
            phone.length !== 0) {
            setIsFormFilled(true);
        }
        else {
            setIsFormFilled(false);
        }
    }, [firstName, lastName, phone]);
    (0, react_1.useEffect)(() => {
        if (firstName === originalData.firstName &&
            lastName === originalData.lastName &&
            phone === originalData.phone) {
            setIsformChanged(false);
        }
        else {
            setIsformChanged(true);
        }
        console.log(isFormChanged, originalData);
    }, [firstName, lastName, phone, originalData]);
    const resetErrors = () => {
        setPhoneErrorState("");
        setFirstNameErrorState("");
        setLastNameErrorState("");
    };
    const checkInvalidFields = (response) => {
        if (response.message != "invalid_fields") {
            return false;
        }
        if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
                let d = response.data[i];
                if (d == "phone") {
                    setPhoneErrorState("A megadott telefonszám nem megfelelő!");
                }
                if (d == "first_name") {
                    setFirstNameErrorState("A megadott keresztnév nem megfelelő!");
                }
                if (d == "family_name") {
                    setLastNameErrorState("A megadott vezetéknév nem megfelelő!");
                }
            }
        }
    };
    const dataChanegHandle = (e) => {
        e.preventDefault();
        resetErrors();
        setIsDataChanged({ changed: false, error: false });
        fetch("/profile", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                first_name: firstName,
                family_name: lastName,
                phone: phone,
            }),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (!content.success) {
                    checkInvalidFields(content.response);
                    return false;
                }
                setIsDataChanged({ changed: true, error: false });
                setOriginalData({ firstName, lastName, phone });
            })
                .catch(() => {
                setIsDataChanged({ changed: false, error: true });
            });
        })
            .catch(() => { });
    };
    const resetPasswordHandle = () => {
        setPasswordResetDone(false);
        fetch("/profile/password-reset", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (!content.success) {
                    return false;
                }
                if (content.response.email) {
                    setResetEmailSentTo(content.response.email);
                }
                setPasswordResetDone(true);
            })
                .catch(() => { });
        })
            .catch(() => { });
    };
    const resetEmailHandle = () => {
        setEmailResetDone(false);
        fetch("/profile/email-reset", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (!content.success) {
                    return false;
                }
                if (content.response.email) {
                    setResetEmailSentTo(content.response.email);
                }
                setEmailResetDone(true);
            })
                .catch(() => { });
        })
            .catch(() => { });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IdHeader_1.default, { handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("main", { className: "profile" },
            react_1.default.createElement("section", { className: "profile__content" },
                react_1.default.createElement("div", { className: "profile__form-container" },
                    react_1.default.createElement("h1", { className: "profile__title" }, "User details"),
                    react_1.default.createElement("form", { className: "profile__form", method: "post", onSubmit: dataChanegHandle },
                        react_1.default.createElement("div", { className: "profile__inputs" },
                            react_1.default.createElement(TextInput_1.default, { label: "First name", name: "firstname", value: firstName, onChangeHandler: setFirstName, placeholder: "Enter your first name", isRequired: true, type: "text", state: firstNameError != ""
                                    ? "error"
                                    : "normal", errorText: firstNameError, unit: "" }),
                            react_1.default.createElement(TextInput_1.default, { label: "Last name", name: "family_name", value: lastName, onChangeHandler: setLastName, placeholder: "Enter your last name", isRequired: true, type: "text", state: lastNameError != "" ? "error" : "normal", errorText: lastNameError, unit: "" }),
                            react_1.default.createElement(TextInput_1.default, { label: "Phone", name: "phone", value: phone, onChangeHandler: setPhone, placeholder: "Enter your phone number", isRequired: true, type: "text", state: phoneError != "" ? "error" : "normal", errorText: phoneError, unit: "" })),
                        react_1.default.createElement("div", { className: "profile__button-container" },
                            react_1.default.createElement(Button_1.default, { state: "enabled", label: "Change password", type: "secondary", icon: IconType_1.default.None, handlerFunction: resetPasswordHandle }),
                            react_1.default.createElement(Button_1.default, { state: isFormFilled && isFormChanged
                                    ? "enabled"
                                    : "disabled", label: "Save changes", type: "primary", icon: IconType_1.default.None, handlerFunction: () => { }, action: "submit" })),
                        react_1.default.createElement("div", { className: "profile__tertiary-buttons" },
                            react_1.default.createElement(ArrowButton_1.default, { direction: "left", label: "Logout", handlerFunction: function () {
                                    window.location.href = "/logout";
                                } }))))),
            react_1.default.createElement("div", { className: "profile__illustration" },
                react_1.default.createElement("h1", { className: "profile__title-mobile" }, "User details"),
                react_1.default.createElement(IllustrationNoDrawing_1.default, null,
                    react_1.default.createElement(react_1.default.Fragment, null)))),
        isPasswordResetDone ? (react_1.default.createElement(ResetPasswordEmailSent_1.default, { email: resetEmailSentTo, closeFunction: () => {
                setPasswordResetDone(false);
            } })) : null,
        isEmailResetDone ? (react_1.default.createElement(ResetEmailEmailSent_1.default, { email: resetEmailSentTo, closeFunction: () => {
                setEmailResetDone(false);
            } })) : null,
        isDataChanged.changed === true && (react_1.default.createElement(Alert_1.default, { type: "success", label: "Sikeresesn megv\u00E1ltoztattad az adataid!", closeFunction: () => setIsDataChanged({ changed: false, error: false }) })),
        isDataChanged.error === true && (react_1.default.createElement(Alert_1.default, { type: "error", label: "Az adatok m\u00F3dos\u00EDt\u00E1sa sikertelen!", closeFunction: () => setIsDataChanged({ changed: false, error: false }) }))));
};
exports.default = Profile;
if (document.getElementById("user-profile")) {
    (0, client_1.createRoot)(document.getElementById("user-profile")).render(react_1.default.createElement(Profile, null));
}
